import { NgModule }            from '@angular/core';
import { CommonModule }        from '@angular/common';
import { RouterModule }        from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { MaterialModule }  from '@shared/material/material.module';
import { PipesModule }     from '@shared/pipes/pipes.module';
import { IconsModule }     from '@shared/icons/icons.module';
import { LoadingModule }   from '@shared/loading/loading.module';
import { ScrollingModule } from '@shared/scrolling/scrolling.module';
import { AlertBoxModule }  from '@shared/alert-box/alert-box.module';

import { FeaturedThemesComponent } from './featured-themes/featured-themes.component';
import { EndingTasksComponent }    from './ending-tasks/ending-tasks.component';
import { StudentsListComponent }   from './students-list/red-students-list.component';
import { RankingComponent }        from './ranking/ranking.component';
import { ClassesListComponent }    from './classes-list/classes-list.component';


@NgModule({
  declarations: [
    FeaturedThemesComponent,
    EndingTasksComponent,
    StudentsListComponent,
    RankingComponent,
    ClassesListComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LoadingModule,
    ScrollingModule,
    PipesModule,
    MaterialModule,
    IconsModule,
    RouterModule,
    AlertBoxModule
  ],
  exports:      [
    FeaturedThemesComponent,
    EndingTasksComponent,
    StudentsListComponent,
    RankingComponent,
    ClassesListComponent
  ]
})
export class SectionsModule {}
